import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.date.to-iso-string.js";
import { parseISO } from 'date-fns';
export function convertStrToDate(value) {
  // Please do not remove this without extra consideration. Dates without times are meaningless, and we
  // should be encouraging precise date handling in a multicultural and cross-country company such as AB
  // https://stackoverflow.com/a/52869830
  if (!isIsoDate(value)) {
    throw new Error('Dates must be in ISO 8601 datetime format');
  }
  return parseISO(value);
}
export function isIsoDate(str) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) {
    return false;
  }
  var d = new Date(str);
  return d instanceof Date &&
  // @ts-expect-error Allow passing date type to isNaN
  !isNaN(d) && d.toISOString() === str;
}